import ReactGA from "react-ga4"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"

export const initGA = () => {
  console.log("initGA")
  ReactGA.initialize("G-M2W2HT4MC2")
}

ReactGA.initialize("G-M2W2HT4MC2")

export const addPageView = url => {
  console.log("addPageView:", url)
  ReactGA.send({ hitType: "pageview", page: url })
  // ReactGA.pageview(url)
}

export const recordEvent = (
  a = "Action?",
  c = "Category?",
  l = ""
) => {
  initGA()
  console.log('recordEvent', a, c, l)
  // typeof window !== "undefined" &&
  //   window.gtag("event", c, {
  //     // string - required - The object that was interacted with (e.g.video)
  //     category: c,
  //     // string - required - Type of interaction (e.g. 'play')
  //     action: a,
  //     // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
  //     label: l,
  //     // number - optional - Numeric value associated with the event. (e.g. A product ID)
  //     // value: 43,
  //   })
  // trackCustomEvent({
  //   // string - required - The object that was interacted with (e.g.video)
  //   category: c,
  //   // string - required - Type of interaction (e.g. 'play')
  //   action: a,
  //   // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
  //   label: l,
  //   // number - optional - Numeric value associated with the event. (e.g. A product ID)
  //   // value: 43,
  // })
  ReactGA.event({
    action: a,
    category: c,
    label: l,
    nonInteraction: false,
  })
}
